import { createTheme, ThemeProvider as MuiThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { createContext, useState, useContext } from "react";

export const THEMES = {
  dark: {
    low:    { label: "Sombre — Doux",      bg: "#1a1a1f", text: "#a8a8b8", headerBg: "#101015", accent: "#1a237e" },
    medium: { label: "Sombre — Standard",  bg: "#111118", text: "#c0c0d8", headerBg: "#08080d", accent: "#1a237e" },
    high:   { label: "Sombre — Contrasté", bg: "#0a0a0f", text: "#d8d8f0", headerBg: "#040407", accent: "#283593" },
  },
  light: {
    low:    { label: "Clair — Très doux",  bg: "#f0ede8", text: "#555050", headerBg: "#3d3835", accent: "#3d3835" },
    medium: { label: "Clair — Standard",   bg: "#f5f3f0", text: "#444040", headerBg: "#302c2a", accent: "#302c2a" },
    high:   { label: "Clair — Contrasté",  bg: "#fafaf8", text: "#2a2828", headerBg: "#252222", accent: "#252222" },
  },
};

const getTheme = (mode, appTheme) =>
  createTheme({
    palette: {
      mode,
      background: { default: appTheme.bg },
    },
    custom: {
      mymodal: {
        main:   mode === "dark" ? "rgba(20,24,30,0.95)" : "#ffffff",
        text:   appTheme.text,
        button: appTheme.accent,
        border: mode === "dark" ? "1px solid #2f3545" : "1px solid #d3d7df",
      },
      myheader: {
        main: appTheme.headerBg,
        text: "#ffffff",
      },
    },
  });

const ThemeContext = createContext();

export function ThemeProvider({ children }) {
  const [mode, setMode] = useState(
    () => localStorage.getItem("theme-mode") || "dark"
  );
  const [intensity, setIntensity] = useState(
    () => localStorage.getItem("theme-intensity") || "medium"
  );

  const appTheme = THEMES[mode][intensity];

  const changeMode = (newMode) => {
    setMode(newMode);
    localStorage.setItem("theme-mode", newMode);
  };

  const changeIntensity = (newIntensity) => {
    setIntensity(newIntensity);
    localStorage.setItem("theme-intensity", newIntensity);
  };

  return (
    <ThemeContext.Provider value={{ mode, intensity, appTheme, changeMode, changeIntensity }}>
      <MuiThemeProvider theme={getTheme(mode, appTheme)}>
        <CssBaseline />
        {children}
      </MuiThemeProvider>
    </ThemeContext.Provider>
  );
}

export function useThemeMode() {
  return useContext(ThemeContext);
}
